// extracted by mini-css-extract-plugin
export default {"loginContainer":"styles_loginContainer__zic2J","loginWrapper":"styles_loginWrapper__Iz6eV","customInput":"styles_customInput__KPeGR","errorAlert":"styles_errorAlert__CveDG"};